import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const heroSlides = [
  {
    image: '/img/slider/beautiful-car-washing-service 1-min.png',
    h5: 'Welcome To Green Kleen',
    h2: 'Your One-Stop Eco-Friendly Car Care Solution',
    p: 'At Green Kleen, we revolutionize car care with our innovative waterless cleaning solutions. Our products are designed to deliver exceptional results while conserving water and protecting the environment.',
    btn: 'Discover More',
    btnLink: '/contact',
  },
  {
    image: '/img/slider/slider%202-min.png',
    h5: 'Green Kleen - Waterless Car Cleaning',
    h2: 'Wide Range of Eco-Friendly Auto Care Products',
    p: 'We take pride in offering a comprehensive selection of sustainable auto care solutions tailored to meet every vehicle’s needs. Our products are formulated to clean, shine, and protect your vehicle without the use of water, ensuring an eco-conscious approach to car maintenance.',
    btn: 'Discover More',
    btnLink: '/contact',
  },
];

const Home = () => {
  const [current, setCurrent] = useState(0);
  const nextSlide = () => setCurrent((current + 1) % heroSlides.length);
  const prevSlide = () => setCurrent((current - 1 + heroSlides.length) % heroSlides.length);

  return (
    <div className="home">
      {/* Modern Hero Slider Section */}
      <section className="modern-hero-slider">
        {heroSlides.map((slide, idx) => (
          <div
            className={`modern-hero-slide${idx === current ? ' active' : ''}`}
            key={idx}
            style={{ display: idx === current ? 'flex' : 'none' }}
          >
            <img 
              src={slide.image} 
              alt={slide.h2} 
              className={`modern-hero-img${idx === current ? ' zoom' : ''}`}
            />
            <div className="modern-hero-gradient" />
            <div className="modern-hero-content">
              <h5>{slide.h5}</h5>
              <h2>{slide.h2}</h2>
              <p>{slide.p}</p>
              <div className="modern-hero-btns">
                <Link to={slide.btnLink} className="btn btn-primary">
                  {slide.btn} <i className="fas fa-angle-right"></i>
                </Link>
              </div>
            </div>
            <button className="modern-slider-arrow prev" onClick={prevSlide} aria-label="Previous Slide">
              <i className="fas fa-angle-left"></i>
            </button>
            <button className="modern-slider-arrow next" onClick={nextSlide} aria-label="Next Slide">
              <i className="fas fa-angle-right"></i>
            </button>
          </div>
        ))}
      </section>

      {/* About Section */}
      <section className="about-section section">
        <div className="container">
          <div className="about-grid">
            <div className="about-image">
              <img src="img/features/76 9-min.png" alt="About Green Kleen" />
              <div className="experience-badge">
                <span className="number">25</span>
                <p>Years of Experience</p>
              </div>
            </div>
            <div className="about-content">
              <div className="section-title">
                <h5>About Company</h5>
                {/* <h2>Make your car feel like a brand new one</h2> */}
              </div>
              <p>
                Established in 2010, Green Kleen has become Oman's pioneering name in mobile waterless car cleaning services. 
                With a commitment to sustainability and innovation, we revolutionized car care by introducing eco-friendly, 
                water-conserving solutions to the region.
              </p>
              <p>
                Today, we proudly operate 16 convenient outlets across major cities, including Muscat, Suhar, and Sur. 
                Our unique mobile concept ensures top-quality car cleaning services delivered directly to our customers, 
                saving time, water, and resources.
              </p>
              <ul className="features-list">
                <li>Eco-Friendly Commitment: We are dedicated to protecting the environment through sustainable car care practices.</li>
                <li>Unmatched Convenience: Enjoy hassle-free service designed to fit your busy lifestyle.</li>
                <li>Exceptional Results: Experience professional-quality cleaning with a focus on excellence and care.</li>
              </ul>
              <Link to="/contact" className="btn btn-primary">
                Know More <i className="fas fa-angle-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section section" style={{ background: '#f7fafd' }}>
        <div className="container">
          <div className="section-title">
            <h2>Join Us in the Mission to Save Water and Protect Our Planet</h2>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <img src="img/icon/sve-icon4.png" alt="Innovations" />
              </div>
              <div className="service-content">
                <h5>OUR INNOVATIONS</h5>
                <p>
                  Green Kleen is at the forefront of eco-friendly car care innovation. Our advanced formulations not only 
                  clean your vehicle but also contribute to water conservation efforts, ensuring a better planet for future generations.
                </p>
              </div>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <img src="img/icon/sve-icon5.png" alt="Difference" />
              </div>
              <div className="service-content">
                <h5>THE GREEN KLEEN DIFFERENCE</h5>
                <ul>
                  <li><strong>Innovative Products:</strong> Utilizing advanced formulations for superior cleaning and protection.</li>
                  <li><strong>Customer-Centric Approach:</strong> Focusing on user-friendly solutions for everyday drivers and car enthusiasts alike.</li>
                  <li><strong>Environmental Commitment:</strong> Prioritizing eco-friendly practices in all aspects of our product development.</li>
                </ul>
              </div>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <img src="img/icon/sve-icon6.png" alt="Who We Are" />
              </div>
              <div className="service-content">
                <h5>WHO WE ARE</h5>
                <p>
                  Green Kleen is a leading car care brand dedicated to providing high-quality, innovative, and sustainable solutions. 
                  We proudly serve customers across Oman.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section section">
        <div className="container">
          <div className="section-title">
            <h5>Our Services</h5>
            <h2>What We Provide</h2>
          </div>
          <div className="features-grid">
            <div className="features-list-left">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="img/icon/Carwash1.png" alt="Gentle Cleaning" />
                </div>
                <div className="feature-content">
                  <h4>Gentle on Your Vehicle's Surface</h4>
                  <p>Cleans effectively without scratching or damaging your car's finish.</p>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="img/icon/Savewater.png" alt="Water Conservation" />
                </div>
                <div className="feature-content">
                  <h4>Conserve 20 to 50 Gallons of Water Per Wash</h4>
                  <p>Save water with our eco-friendly, waterless car wash solution.</p>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="img/icon/dust remove.png" alt="Comprehensive Cleaning" />
                </div>
                <div className="feature-content">
                  <h4>Comprehensive Cleaning</h4>
                  <p>Removes dirt, grime, and residue for a spotless shine.</p>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="img/icon/environment-friendly.png" alt="Environmental Protection" />
                </div>
                <div className="feature-content">
                  <h4>Environmental Protection</h4>
                  <p>Eco-safe formula with no harmful runoff or waste.</p>
                </div>
              </div>
            </div>
            
            <div className="features-image">
              <img src="img/features/image (3)-min.png" alt="Car Care Features" />
            </div>
            
            <div className="features-list-right">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="img/icon/car production.png" alt="Three Steps" />
                </div>
                <div className="feature-content">
                  <h4>Three Simple Steps to a Protective Finish</h4>
                  <p>Just spray, wipe, and buff for lasting protection.</p>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="img/icon/save money.png" alt="Cost Effective" />
                </div>
                <div className="feature-content">
                  <h4>Cost-Effective and Easy Application</h4>
                  <p>Affordable and easy to use—no special tools needed.</p>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="img/icon/Long time.png" alt="Long Lasting" />
                </div>
                <div className="feature-content">
                  <h4>Long-Lasting Shine and Protection</h4>
                  <p>Delivers a glossy finish that lasts and protects.</p>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <img src="img/icon/save time.png" alt="Time Saving" />
                </div>
                <div className="feature-content">
                  <h4>Time-Saving Solution</h4>
                  <p id='cta-content-redirect'>Clean your car in minutes without water or hassle.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section" style={{ backgroundImage: 'url(img/bg/image 1986-min.png)', color: 'white' }}>
        <div className="container" >
          <div className="cta-content" >
            <h3>Car Cleaning at Your Doorstep </h3>
            <h4 className='cta-description'>Keep your car sparkling clean without the hassle! Our professional car cleaning service brings top-notch cleaning right to your doorstep. Whether you're at home, work, or anywhere else, we handle everything from exterior washes to interior deep cleans, using eco-friendly products and expert techniques to ensure your vehicle looks and feels brand new.
            </h4>
            <a 
              href="https://wa.me/96898520852?text=I%20would%20like%20to%20enquire%20/%20book%20car%20cleaning%20service" 
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Inquire on WhatsApp 
                 {/* <i className="fas fa-angle-right"></i> */}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 